import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
// import ObjectManage from './views/ObjectManage.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('./views/login.vue')
    },
    {
      path: '/',
      component: () => import('./App.vue'),
      children: [
        {
          path: '/object-manage',
          name: 'objectmanage',
          component: () => import('./views/ObjectManage.vue')
        },
        {
          path: '/change-password',
          name: 'changepassword',
          component: () => import('./views/ChangePassword.vue')
        }
      ]
    },
    {
      path: '*',
      component: () => import('./views/Error404.vue')
    }
  ]
})
